var map = {
	"./Online learning-pana.svg": 9557,
	"./abt.png": 3163,
	"./b-stud1.jpeg": 2103,
	"./b-teach.png": 5378,
	"./banner-img.svg": 7967,
	"./bb-teach.png": 5601,
	"./bc-1.jpg": 8288,
	"./bc-2.jpg": 731,
	"./bc-3.jpg": 2675,
	"./bc-4.jpg": 8097,
	"./bc-5.jpg": 8653,
	"./bc-6.png": 3541,
	"./bc-7.jpg": 785,
	"./blob.png": 304,
	"./book-1.svg": 7581,
	"./book-2.png": 8022,
	"./book-2.svg": 732,
	"./book-rm.png": 5703,
	"./book.jpg": 3410,
	"./bscience.jfif": 7446,
	"./btech.jfif": 8561,
	"./catherine.jfif": 1449,
	"./christophe.jfif": 2240,
	"./course-app.svg": 6688,
	"./course-appp.svg": 5775,
	"./cynthia.jpeg": 794,
	"./dots.png": 5373,
	"./ele-bg.png": 5588,
	"./elem-bg.png": 7878,
	"./elvis.jfif": 6419,
	"./error-404-1.svg": 5923,
	"./error-404-2.svg": 486,
	"./error-404.svg": 4967,
	"./error-500.svg": 3277,
	"./female-teach.svg": 5726,
	"./icon-1.png": 5117,
	"./icon-10.png": 1784,
	"./icon-11.png": 8795,
	"./icon-12.png": 6918,
	"./icon-13.png": 8232,
	"./icon-14.png": 8859,
	"./icon-2.png": 4515,
	"./icon-3.png": 774,
	"./icon-4.png": 2027,
	"./icon-5.png": 7346,
	"./icon-6-sm.png": 9835,
	"./icon-6.png": 3738,
	"./icon-7.png": 5264,
	"./icon-8.png": 4627,
	"./infotech.jpg": 2536,
	"./joseph.jpeg": 4321,
	"./josephh.jpeg": 3588,
	"./kids-with-kite.png": 3768,
	"./logo-m.png": 8451,
	"./logo.png": 5080,
	"./mary.jfif": 9873,
	"./path1.png": 1608,
	"./path2.png": 5164,
	"./path3.png": 295,
	"./path4.png": 9751,
	"./path5.png": 9599,
	"./physics.jpg": 5900,
	"./sprinkle.svg": 299,
	"./students.jpg": 8502,
	"./teach.jpeg": 3038,
	"./teach.png": 4385,
	"./teacher-2.jpg": 8132,
	"./teacher-3.jpg": 6567,
	"./teacher-4.jpg": 9106,
	"./teacher-5.jpg": 2893,
	"./teacher.jpg": 70,
	"./teacher.png": 9772,
	"./teacher.svg": 7800,
	"./top.png": 200,
	"./wave.png": 1576,
	"./world-map.png": 2419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;